import React from "react";

const WebPages_Files = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Files</h1>
      <p>This is the WebPages Files page content.</p>
    </div>
  );
};

export default WebPages_Files;
